import axios from 'axios';
import { startLoading, stopLoading } from '../utils/loadingController';
import { handleHttpError } from '../utils/errorController';
import refreshAccessToken from '../auth/refreshToken';
import { getClientIp } from '../utils/clientIp';

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  withCredentials: true,
});

axiosInstance.interceptors.request.use(
  async (config) => {
    startLoading();
    if (config.headers && 'Authorization' in config.headers) {
      delete config.headers.Authorization;
    }

    const clientIp = await getClientIp();
    if (clientIp) {
      config.headers = {
        ...config.headers,
        'X-Client-IP': clientIp,
      };
    }

    return config;
  },
  (error) => {
    stopLoading();
    return Promise.reject(error);
  },
);

axiosInstance.interceptors.response.use(
  (response) => {
    stopLoading();
    return response;
  },
  async (error) => {
    stopLoading();
    if (error?.code === 'ERR_CANCELED') {
      return Promise.reject(error);
    }

    // Network or server unreachable
    if (!error.response) {
      handleHttpError();
      window.location.href = '/offline';
      return Promise.reject(error);
    }

    const { config, response } = error;
    if (response.status === 401 && !config._retry) {
      config._retry = true;
      try {
        await refreshAccessToken();
        return axiosInstance(config);
      } catch (refreshError) {
        window.location.href = '/sign-in';
        return Promise.reject(refreshError);
      }
    }

    const responseMessage = Array.isArray(response?.data?.message)
      ? response.data.message[0]
      : response?.data?.message;
    handleHttpError(response.status, responseMessage);
    if (response.status === 401) {
      window.location.href = '/sign-in';
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
